/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-05.
 * General config for the app.
 * Server - https://sicom.afsforwarding.com/afs/v1/
 * noContent is displayed when a route does not exist
 */
import { orderBy } from 'lodash';
import { NoContent } from './components/layout';
import {
    //Playground,
    Despachos,
    Users,
    Aduanas,
    Conceptos,
    Status,
    Proveedores,
    Clientes,
    Reportes,
    Home
} from './containers';
import {
    CUSTOMS_CLEARENCE_PERMISSION,
    CUSTOMERS_PERMISSION,
    USERS_PERMISSION,
    CUSTOMS_HOUSES_PERMISSION,
    INVOICE_ITEM_PERMISSION,
    CUSTOMS_CLEARENCE_STATUSES_PERMISSION,
    SUPPLIERS_PERMISSION,
    REPORTS_PERMISSION
} from './security/permissions';

export const feeTax = 16;
export const apiUrl = 'http://localhost:8080/afs/v1/';

const home = {
    key: 'home',
    title: 'Inicio',
    path: '/',
    exact: true,
    component: Home
};

const noContent = {
    key: 'noContent',
    title: 'Página no encontrada',
    component: NoContent
};

/*const playground = {
    key: 'playground',
    title: 'PlayGround',
    path: '/playground',
    exact: true,
    component: Playground
};*/

/**
 * Important!
 * item keys must match permission types
 */
const menu = [
    {
        key: CUSTOMS_CLEARENCE_PERMISSION,
        title: 'Despachos Aduaneros',
        path: '/despachos-aduaneros',
        exact: true,
        component: Despachos
    },
    {
        key: CUSTOMERS_PERMISSION,
        title: 'Clientes',
        path: '/clientes',
        exact: true,
        component: Clientes
    },
    {
        key: USERS_PERMISSION,
        title: 'Usuarios',
        path: '/usuarios',
        exact: true,
        component: Users
    },
    {
        key: CUSTOMS_HOUSES_PERMISSION,
        title: 'Aduanas',
        path: '/aduanas',
        exact: true,
        component: Aduanas
    },
    {
        key: INVOICE_ITEM_PERMISSION,
        title: 'Conceptos de Facturación',
        path: '/conceptos',
        exact: true,
        component: Conceptos
    },
    {
        key: CUSTOMS_CLEARENCE_STATUSES_PERMISSION,
        title: 'Estatus de Despachos',
        path: '/estatus',
        exact: true,
        component: Status
    },
    {
        key: SUPPLIERS_PERMISSION,
        title: 'Proveedores',
        path: '/proveedores',
        exact: true,
        component: Proveedores
    },
    {
        key: REPORTS_PERMISSION,
        title: 'Reportes',
        path: '/reportes',
        exact: true,
        component: Reportes
    },
];

export const getMenu = (permissions = {}) => {
    const validItems = menu.filter(item => permissions[item.key] && permissions[item.key].read === true);
    const orderedItems = orderBy(validItems, ['title']);

    return Promise.resolve([home, ...orderedItems, noContent]);
};



// WEBPACK FOOTER //
// ./app.config.js